export const FORSUBMIT = {
  REQUEST: 'Units/ForSubmit/Request',
  SUCCESS: 'Units/ForSubmit/Success',
  FAILURE: 'Units/ForSubmit/Failure'
};

export const GET = {
  REQUEST: 'Units/Get/Request',
  SUCCESS: 'Units/Get/Success',
  FAILURE: 'Units/Get/Failure'
};

export const CREATE = {
  REQUEST: 'Units/Create/Request',
  SUCCESS: 'Units/Create/Success',
  FAILURE: 'Units/Create/Failure'
};

export const UPDATE = {
  REQUEST: 'Units/Update/Request',
  SUCCESS: 'Units/Update/Success',
  FAILURE: 'Units/Update/Failure'
};

export const CLEAR = {
  REQUEST: 'Units/Clear/Request',
  SUCCESS: 'Units/Clear/Success',
  FAILURE: 'Units/Clear/Failure'
};

export const DELETE = {
  REQUEST: 'Units/Delete/Request',
  SUCCESS: 'Units/Delete/Success',
  FAILURE: 'Units/Delete/Failure'
};
